var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_529_83093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.77996 27.13C7.77996 27.13 6.95996 26.31 6.95996 25.3V6.68999C6.95996 5.67999 7.76996 4.85999 8.77996 4.85999H21.96C22.96 4.85999 23.78 5.67999 23.78 6.68999V25.3C23.78 26.31 22.96 27.13 21.96 27.13H8.77996Z",
    fill: "#EBF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.96 5.29999C22.72 5.29999 23.34 5.91999 23.34 6.68999V25.3C23.34 26.07 22.72 26.69 21.96 26.69H8.78003C8.02003 26.69 7.40003 26.07 7.40003 25.3V6.68999C7.40003 5.91999 8.02003 5.29999 8.78003 5.29999H21.96ZM21.96 4.42999H8.78003C7.54003 4.42999 6.53003 5.43999 6.53003 6.68999V25.3C6.53003 26.55 7.54003 27.56 8.78003 27.56H21.96C23.2 27.56 24.21 26.55 24.21 25.3V6.68999C24.21 5.43999 23.2 4.42999 21.96 4.42999Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.95996 8.29V5.82C6.95996 5.29 7.38996 4.87 7.90996 4.87H22.82C23.35 4.87 23.77 5.3 23.77 5.82V8.29H6.95996Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.82 5.29999C23.11 5.29999 23.34 5.52999 23.34 5.81999V7.84999H7.40003V5.81999C7.40003 5.52999 7.63003 5.29999 7.92003 5.29999H22.83M22.83 4.42999H7.92003C7.15003 4.42999 6.53003 5.04999 6.53003 5.81999V8.71999H24.21V5.81999C24.21 5.04999 23.59 4.42999 22.82 4.42999H22.83Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.03992 6.95002C9.24427 6.95002 9.40992 6.78437 9.40992 6.58002C9.40992 6.37568 9.24427 6.21002 9.03992 6.21002C8.83558 6.21002 8.66992 6.37568 8.66992 6.58002C8.66992 6.78437 8.83558 6.95002 9.03992 6.95002Z",
    fill: "#FF0059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.16 6.95002C10.3644 6.95002 10.53 6.78437 10.53 6.58002C10.53 6.37568 10.3644 6.21002 10.16 6.21002C9.95569 6.21002 9.79004 6.37568 9.79004 6.58002C9.79004 6.78437 9.95569 6.95002 10.16 6.95002Z",
    fill: "#F9CD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.2599 10.73H9.06992C8.84901 10.73 8.66992 10.9091 8.66992 11.13C8.66992 11.3509 8.84901 11.53 9.06992 11.53H11.2599C11.4808 11.53 11.6599 11.3509 11.6599 11.13C11.6599 10.9091 11.4808 10.73 11.2599 10.73Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.0299 12.6H9.06992C8.84901 12.6 8.66992 12.7791 8.66992 13C8.66992 13.2209 8.84901 13.4 9.06992 13.4H10.0299C10.2508 13.4 10.4299 13.2209 10.4299 13C10.4299 12.7791 10.2508 12.6 10.0299 12.6Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.3099 14.47H9.06992C8.84901 14.47 8.66992 14.6491 8.66992 14.87C8.66992 15.0909 8.84901 15.27 9.06992 15.27H12.3099C12.5308 15.27 12.7099 15.0909 12.7099 14.87C12.7099 14.6491 12.5308 14.47 12.3099 14.47Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.0999 16.34H9.06992C8.84901 16.34 8.66992 16.5191 8.66992 16.74C8.66992 16.9609 8.84901 17.14 9.06992 17.14H11.0999C11.3208 17.14 11.4999 16.9609 11.4999 16.74C11.4999 16.5191 11.3208 16.34 11.0999 16.34Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.2599 18.22H9.06992C8.84901 18.22 8.66992 18.3991 8.66992 18.62C8.66992 18.8409 8.84901 19.02 9.06992 19.02H11.2599C11.4808 19.02 11.6599 18.8409 11.6599 18.62C11.6599 18.3991 11.4808 18.22 11.2599 18.22Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.0299 20.09H9.06992C8.84901 20.09 8.66992 20.2691 8.66992 20.49C8.66992 20.7109 8.84901 20.89 9.06992 20.89H10.0299C10.2508 20.89 10.4299 20.7109 10.4299 20.49C10.4299 20.2691 10.2508 20.09 10.0299 20.09Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.3099 21.96H9.06992C8.84901 21.96 8.66992 22.1391 8.66992 22.36C8.66992 22.5809 8.84901 22.76 9.06992 22.76H12.3099C12.5308 22.76 12.7099 22.5809 12.7099 22.36C12.7099 22.1391 12.5308 21.96 12.3099 21.96Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.0999 23.83H9.06992C8.84901 23.83 8.66992 24.0091 8.66992 24.23C8.66992 24.4509 8.84901 24.63 9.06992 24.63H11.0999C11.3208 24.63 11.4999 24.4509 11.4999 24.23C11.4999 24.0091 11.3208 23.83 11.0999 23.83Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.2799 6.95002C11.4843 6.95002 11.6499 6.78437 11.6499 6.58002C11.6499 6.37568 11.4843 6.21002 11.2799 6.21002C11.0756 6.21002 10.9099 6.37568 10.9099 6.58002C10.9099 6.78437 11.0756 6.95002 11.2799 6.95002Z",
    fill: "#00BD4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M27.22 11.58H12.57C11.9735 11.58 11.49 12.0635 11.49 12.66V15.31C11.49 15.9065 11.9735 16.39 12.57 16.39H27.22C27.8165 16.39 28.3 15.9065 28.3 15.31V12.66C28.3 12.0635 27.8165 11.58 27.22 11.58Z",
    fill: "#8ECBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M27.22 12.01C27.58 12.01 27.87 12.3 27.87 12.66V15.31C27.87 15.67 27.58 15.96 27.22 15.96H12.56C12.2 15.96 11.91 15.67 11.91 15.31V12.66C11.91 12.3 12.2 12.01 12.56 12.01H27.22ZM27.22 11.14H12.56C11.73 11.14 11.05 11.82 11.05 12.65V15.3C11.05 16.13 11.73 16.81 12.56 16.81H27.22C28.05 16.81 28.73 16.13 28.73 15.3V12.65C28.73 11.82 28.05 11.14 27.22 11.14Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.22 18.63H12.57C11.9735 18.63 11.49 19.1135 11.49 19.71V22.36C11.49 22.9565 11.9735 23.44 12.57 23.44H27.22C27.8165 23.44 28.3 22.9565 28.3 22.36V19.71C28.3 19.1135 27.8165 18.63 27.22 18.63Z",
    fill: "#F9D18B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M27.22 19.07C27.58 19.07 27.87 19.36 27.87 19.72V22.37C27.87 22.73 27.58 23.02 27.22 23.02H12.56C12.2 23.02 11.91 22.73 11.91 22.37V19.72C11.91 19.36 12.2 19.07 12.56 19.07H27.22ZM27.22 18.2H12.56C11.73 18.2 11.05 18.88 11.05 19.71V22.36C11.05 23.19 11.73 23.87 12.56 23.87H27.22C28.05 23.87 28.73 23.19 28.73 22.36V19.71C28.73 18.88 28.05 18.2 27.22 18.2Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.4,
    d: "M26.8101 13.64H25.7401C25.6301 13.64 25.5401 13.6 25.4601 13.53C25.3901 13.46 25.3401 13.36 25.3401 13.24C25.3401 13.23 25.3401 13.21 25.3401 13.2C25.3401 13.18 25.3401 13.16 25.3401 13.15C25.3401 13.15 25.3401 13.15 25.3401 13.14C25.3401 13.16 25.3401 13.17 25.3601 13.19C25.4201 13.33 25.5601 13.43 25.7201 13.43H26.7801C26.9601 13.43 27.1201 13.3 27.1601 13.14C27.1701 13.18 27.1801 13.21 27.1801 13.25C27.1801 13.47 27.0101 13.65 26.7901 13.65L26.8101 13.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M14.0501 12.73H12.9901C12.7692 12.73 12.5901 12.9091 12.5901 13.13C12.5901 13.3509 12.7692 13.53 12.9901 13.53H14.0501C14.271 13.53 14.4501 13.3509 14.4501 13.13C14.4501 12.9091 14.271 12.73 14.0501 12.73Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    opacity: 0.4,
    d: "M19.47 15.38H18.4C18.33 15.38 18.26 15.36 18.2 15.32C18.08 15.25 18 15.12 18 14.97C18 14.97 18 14.97 18 14.96C18 14.93 18 14.89 18.02 14.86C18.02 14.88 18.02 14.89 18.04 14.91C18.1 15.05 18.24 15.15 18.4 15.15H19.46C19.64 15.15 19.8 15.03 19.84 14.86C19.85 14.9 19.86 14.93 19.86 14.97C19.86 15.19 19.68 15.37 19.47 15.37V15.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M19.9301 12.73H16.0101C15.7892 12.73 15.6101 12.9091 15.6101 13.13C15.6101 13.3509 15.7892 13.53 16.0101 13.53H19.9301C20.151 13.53 20.3301 13.3509 20.3301 13.13C20.3301 12.9091 20.151 12.73 19.9301 12.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M24.9401 14.44H21.0201C20.7992 14.44 20.6201 14.6191 20.6201 14.84C20.6201 15.0609 20.7992 15.24 21.0201 15.24H24.9401C25.161 15.24 25.3401 15.0609 25.3401 14.84C25.3401 14.6191 25.161 14.44 24.9401 14.44Z",
    fill: "#F4AB55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    opacity: 0.4,
    d: "M14.0601 15.38H12.9901C12.7701 15.38 12.5901 15.2 12.5901 14.98C12.5901 14.94 12.5901 14.91 12.6101 14.87C12.6101 14.89 12.6101 14.9 12.6301 14.92C12.6901 15.06 12.8301 15.16 12.9901 15.16H14.0501C14.2301 15.16 14.3901 15.04 14.4301 14.87C14.4401 14.91 14.4501 14.94 14.4501 14.98C14.4501 15.2 14.2701 15.38 14.0601 15.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.0501 14.44H12.9901C12.7692 14.44 12.5901 14.6191 12.5901 14.84C12.5901 15.0609 12.7692 15.24 12.9901 15.24H14.0501C14.271 15.24 14.4501 15.0609 14.4501 14.84C14.4501 14.6191 14.271 14.44 14.0501 14.44Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M16.67 14.44H15.61C15.389 14.44 15.21 14.6191 15.21 14.84C15.21 15.0609 15.389 15.24 15.61 15.24H16.67C16.8909 15.24 17.07 15.0609 17.07 14.84C17.07 14.6191 16.8909 14.44 16.67 14.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M19.46 14.44H18.4C18.1791 14.44 18 14.6191 18 14.84C18 15.0609 18.1791 15.24 18.4 15.24H19.46C19.6809 15.24 19.86 15.0609 19.86 14.84C19.86 14.6191 19.6809 14.44 19.46 14.44Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M24.05 12.73H21.66C21.4391 12.73 21.26 12.9091 21.26 13.13C21.26 13.3509 21.4391 13.53 21.66 13.53H24.05C24.2709 13.53 24.45 13.3509 24.45 13.13C24.45 12.9091 24.2709 12.73 24.05 12.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M26.8001 12.73H25.7401C25.5192 12.73 25.3401 12.9091 25.3401 13.13C25.3401 13.3509 25.5192 13.53 25.7401 13.53H26.8001C27.021 13.53 27.2001 13.3509 27.2001 13.13C27.2001 12.9091 27.021 12.73 26.8001 12.73Z",
    fill: "#63B1EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M27.1999 14.84C27.1999 14.6191 27.0208 14.44 26.7999 14.44C26.579 14.44 26.3999 14.6191 26.3999 14.84C26.3999 15.0609 26.579 15.24 26.7999 15.24C27.0208 15.24 27.1999 15.0609 27.1999 14.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M13.5101 21.99C13.4601 21.99 13.4101 21.97 13.3701 21.93L12.6601 21.22C12.5801 21.14 12.5801 21.01 12.6601 20.93L13.4301 20.15C13.5101 20.07 13.6401 20.07 13.7201 20.15C13.8001 20.23 13.8001 20.36 13.7201 20.44L13.0901 21.07L13.6601 21.64C13.7401 21.72 13.7401 21.85 13.6601 21.93C13.6201 21.97 13.5701 21.99 13.5201 21.99H13.5101Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M14.17 22.36C14.17 22.36 14.12 22.36 14.1 22.35C13.99 22.31 13.94 22.19 13.98 22.08L14.85 19.84C14.89 19.73 15.01 19.68 15.11 19.72C15.22 19.76 15.27 19.88 15.23 19.99L14.36 22.23C14.33 22.31 14.25 22.36 14.17 22.36Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M15.71 21.99C15.66 21.99 15.61 21.97 15.57 21.93C15.49 21.85 15.49 21.72 15.57 21.64L16.14 21.07L15.51 20.44C15.43 20.36 15.43 20.23 15.51 20.15C15.59 20.07 15.72 20.07 15.8 20.15L16.57 20.93C16.57 20.93 16.63 21.02 16.63 21.08C16.63 21.14 16.61 21.19 16.57 21.23L15.86 21.94C15.86 21.94 15.77 22 15.72 22L15.71 21.99Z",
    fill: "#171923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_529_83093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedProjects);
export default __webpack_public_path__ + "static/media/CompletedProjects.eed676c722c58f81ad52b582d3a17583.svg";
export { ForwardRef as ReactComponent };